import React from 'react';

import { UiKit } from 'components';

export default function TableCellColumn({ children = null }) {
  return (
    <UiKit.Grid templateColumns="1fr" gap="4">
      {children}
    </UiKit.Grid>
  );
}
